import debounce from './debounce';

export default debounce;
